var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
var DownloadFileComponent = /** @class */ (function () {
    function DownloadFileComponent(util, apiService, activatedRoute) {
        this.util = util;
        this.apiService = apiService;
        this.activatedRoute = activatedRoute;
    }
    DownloadFileComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        this.activatedRoute.queryParams.subscribe(function (params) {
                            _this.fileId = params['file'];
                        });
                        return [4 /*yield*/, this.getFileFromAPI()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DownloadFileComponent.prototype.getFileFromAPI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "annotation", "annotationid=" + this.fileId)];
                    case 1:
                        _a.fileAtch = _b.sent();
                        if (this.fileAtch == null) {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog("เกิดข้อผิดพลาดกรูณาติดต่อเจ้าหน้าที");
                            return [2 /*return*/];
                        }
                        this.downloadBase64File(this.fileAtch.mimetype, this.fileAtch.documentbody, this.fileAtch.filename);
                        return [2 /*return*/];
                }
            });
        });
    };
    DownloadFileComponent.prototype.downloadBase64File = function (contentType, base64Data, fileName) {
        var linkSource = "data:" + contentType + ";base64," + base64Data;
        var downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.util.ShowWaiting(false);
        setTimeout(function () {
            window.close();
        }, 1200);
    };
    return DownloadFileComponent;
}());
export { DownloadFileComponent };



// WEBPACK FOOTER //
// ./src/app/download-file/download-file.component.ts.pre-build-optimizer.js